export default [
  {
    path: "/administration/family-cards",
    name: "family-card-list",
    meta: { title: "Family Cards", authRequired: true },
    component: () => import("../views/administrasi/family-card-list"),
  },
  {
    path: "/administration/family-cards/add",
    name: "family-card-add",
    meta: { title: "Add Family Card", authRequired: true },
    component: () => import("../views/administrasi/family-card-details"),
  },
  {
    path: "/administration/family-cards/:id",
    name: "family-card-view",
    meta: { title: "Family Card Detail", authRequired: true },
    component: () => import("../views/administrasi/family-card-details"),
  },
  {
    path: "/administration/visa-applications",
    name: "visa-application-list",
    meta: { title: "Visa Applications", authRequired: true },
    component: () => import("../views/administrasi/visa-application-list"),
  },
  {
    path: "/administration/visa-applications/add",
    name: "visa-application-add",
    meta: { title: "Add Visa Application", authRequired: true },
    component: () => import("../views/administrasi/visa-application-details"),
  },
  {
    path: "/administration/visa-applications/:id",
    name: "visa-application-view",
    meta: { title: "Visa Application Detail", authRequired: true },
    component: () => import("../views/administrasi/visa-application-details"),
  },
]
